/**
 * Copyright 2022 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export const pluralizeText = (
  count: number,
  noun: string,
  suffix: string = "s"
) => `${count} ${noun}${count !== 1 ? suffix : ""}`;
